import React from 'react'

import { Dialog } from '@did/das-balance-components'
import { useDasBalanceContext } from '@did/das-app-context'
import { ActionDialogType } from '@did/das-balance-types'
import { ReceiveContent } from './receive'
import { SendContent } from './send'

export const ActionDialog: ActionDialogType = ({
  receiveShow,
  sendShow,
  onReceiveShowChange,
  onSendShowChange,
  availableBalance,
  successCallback
}) => {
  const { tt } = useDasBalanceContext()

  return (
    <>
      <Dialog
        showing={receiveShow}
        onClose={() => {
          onReceiveShowChange?.(false)
        }}
        closeButton
        title={tt('Receive') + ' CKB'}
        actionButtonText="$tt('Close')"
      >
        <ReceiveContent />
      </Dialog>
      <Dialog
        showing={sendShow}
        onClose={() => {
          onSendShowChange?.(false)
        }}
        closeButton
        title={tt('Send') + ' CKB'}
        actionButtonText="$tt('Close')"
      >
        <SendContent
          balance={availableBalance}
          successCallback={successCallback}
        />
      </Dialog>
    </>
  )
}
